import { render } from "./editpass.vue?vue&type=template&id=6469290c"
import script from "./editpass.vue?vue&type=script&lang=js"
export * from "./editpass.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__